import {createStore, applyMiddleware, compose} from 'redux';
import thunk from 'redux-thunk';
import backend from '../middleware/backend'
import rootReducer from '../reducers';

export default function configureStore(router, history, initialState) {

	const enhancer = compose(
		applyMiddleware(thunk, backend),
		applyMiddleware(thunk, router)
	);

	return createStore(rootReducer(history), initialState, enhancer); // eslint-disable-line
}
